var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M596.05,0H15.11A15.08,15.08,0,0,0,0,15.05V302.51a15.08,15.08,0,0,0,15.09,15.07h581a15.08,15.08,0,0,0,15-15.07V15.09A15.07,15.07,0,0,0,596.06,0Zm5.06,15.09V291.28l-168.5-184L595.49,10h.56a5.07,5.07,0,0,1,5.06,5.08ZM35.11,10H576L305.56,171.49ZM15,10h.56L178.48,107.3,10,291.3V15.09A5.07,5.07,0,0,1,15,10h.08ZM596,307.61H15.11a5,5,0,0,1-4.26-2.37L187.27,112.5,303,181.61l2.57,1.53L423.85,112.5,600.32,305.21a5,5,0,0,1-4.27,2.37Z"}))));
}

MailIcon.defaultProps = {"viewBox":"0 0 611.11 317.58"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
